import type { AiProvider } from "./ai-chat";

export interface ToolResultBlock {
  output: string;
  isError: boolean;
}

export interface DiffHunk {
  header: string;
  lines: { type: "add" | "remove" | "context"; content: string }[];
}

export type ContentBlock =
  | { type: "text"; text: string }
  | {
      type: "tool_use";
      toolName: string;
      toolId: string;
      input: Record<string, unknown>;
      status: "running" | "done" | "error";
      result?: ToolResultBlock;
    }
  | { type: "thinking"; text: string; isStreaming?: boolean }
  | { type: "image"; url: string; alt?: string }
  | { type: "diff"; filePath: string; hunks: DiffHunk[] }
  | {
      type: "permission";
      toolName: string;
      toolId: string;
      status: "pending" | "approved" | "denied";
    };

export interface ChatTurn {
  id: string;
  role: "user" | "assistant" | "system";
  blocks: ContentBlock[];
  provider?: AiProvider;
  costUsd?: number;
  tokenCount?: { input: number; output: number };
  isStreaming: boolean;
}

export interface ChatAttachment {
  id: string;
  name: string;
  type: "image" | "text";
  content: string;
  sizeBytes: number;
}

export const MAX_ATTACHMENT_BYTES = 100 * 1024; // 100KB

export const IMAGE_EXTENSIONS = new Set([
  "png", "jpg", "jpeg", "gif", "webp", "svg",
]);

export function getFileType(filename: string): ChatAttachment["type"] {
  const ext = filename.split(".").pop()?.toLowerCase() ?? "";
  return IMAGE_EXTENSIONS.has(ext) ? "image" : "text";
}
